import React, {Fragment} from 'react';
import {get, set} from "../../../utils/dotutils";
import isEqual from 'lodash-es/isEqual';
import AddressControl from "../AddressControl";
import {AddressFormatter} from "../../../utils/formatters";
import Select from "../Select";
import TextArea from "../TextArea";
import Button from "../Button";
import classNames from 'classnames';
import {loadComponentById} from "../../../utils/components";
import TextInput from "../TextInput";
import debounce from "../../../utils/debounce";
import PropsProxy from "../../layout/PropsProxy";

class BooklogControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            linkShippingAddress: this.props.linkShippingAddress,
            linkContact: this.props.linkContact,
            value: this.props.value,
        };
        this.loadContact = debounce((partner_id) => {
            this.loadContactRequest && this.loadContactRequest.abort();
            this.loadContactRequest = loadComponentById("partner", partner_id, ["name", "email", "telnum"]);
            this.loadContactRequest.then((customer) => {
                const v = {...this.state.value};
                v.contact = customer.name;
                v.email = customer.email;
                v.telnum = customer.telnum;
                if (!isEqual(v, this.state.value)) {
                    this.setState({
                        value: v,
                    }, () => {
                        this.saveChanges(this.props.name, v);
                    });
                }
            });
        }, 300);
        this.saveChanges = debounce((name, v) => {
            this.props.saveChanges && this.props.saveChanges(name, v);
        }, 300);
        this.initValues();
    }

    setFieldValue = (field, value) => {
        let oldValue = get(this.state.value, field);
        if (!isEqual(oldValue, value)) {
            const v = {...this.state.value};
            set(v, field, value);
            this.setState({
                value: v
            });
            this.saveChanges(this.props.name, v);
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (
            (!isEqual(this.props.value, prevProps.value) && !isEqual(this.props.value, this.state.value))
            ||
            this.props.linkShippingAddress !== prevProps.linkShippingAddress
            ||
            this.props.linkContact !== prevProps.linkContact
        ) {
            this.setState({
                linkShippingAddress: this.props.linkShippingAddress,
                linkContact: this.props.linkContact,
                value: this.props.value,
            });
        }
        if (this.state.linkShippingAddress !== prevState.linkShippingAddress || this.state.linkContact !== prevState.linkContact) {
            this.initValues();
        } else if (!isEqual(this.props.client, prevProps.client)) {
            this.initValues();
        } else if (this.props.autoFill !== prevProps.autoFill) {
            this.initValues();
        }
    }

    initValues = () => {
        if (this.getProps('').disabled) return;
        if (this.props.autoFill !== false) {
            if (this.props.client && this.props.client.values) {
                if ((!this.props.value || !AddressFormatter(this.props.value.pickupaddress)) && AddressFormatter((this.props.client.values.origin || this.props.client.values.source || {}).address)) {
                    this.setFieldValue("pickupaddress", (this.props.client.values.origin || this.props.client.values.source).address);
                }
                if (this.state.linkShippingAddress !== false) {
                    this.recalculateShippingAddress();
                } else {
                    if ((!this.props.value || !AddressFormatter(this.props.value.shippingaddress)) && AddressFormatter((this.props.client.values.destination || this.props.client.values.target || {}).address)) {
                        this.setFieldValue("shippingaddress", (this.props.client.values.destination || this.props.client.values.target).address);
                    } else if ((!this.props.value || !AddressFormatter(this.props.value.shippingaddress)) && AddressFormatter((this.props.client.values.customer || {}).address)) {
                        this.setFieldValue("shippingaddress", this.props.client.values.customer.address);
                    }
                }
                if (this.state.linkContact !== false) {
                    this.loadContact && this.loadContact.cancel();
                    const partner_id = this.props.client.values.customer instanceof Object ? this.props.client.values.customer.partner_id : this.props.client.values.customer;
                    if (partner_id) {
                        this.loadContact(partner_id);
                    }
                }
            }
        }
    }

    recalculateShippingAddress = () => {
        if (AddressFormatter((this.props.client.values.destination || this.props.client.values.target || {}).address)) {
            if (AddressFormatter(this.props.value.shippingaddress) !== AddressFormatter((this.props.client.values.destination || this.props.client.values.target || {}).address)) {
                this.setFieldValue("shippingaddress", (this.props.client.values.destination || this.props.client.values.target).address);
            }
        } else if (AddressFormatter((this.props.client.values.customer || {}).address)) {
            if (AddressFormatter(this.props.value.shippingaddress) !== AddressFormatter((this.props.client.values.customer || {}).address)) {
                this.setFieldValue("shippingaddress", this.props.client.values.customer.address);
            }
        }
    }

    getProps = (name) => {
        let props = {};
        if (this.props.getFieldProps) {
            props = this.props.getFieldProps((this.props.name ? this.props.name + '.' : '') + name);
        }
        const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
        props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
        return props;
    }

    getFields = () => {
        const shippingAddressProps = this.getProps("shippingaddress");
        const contactProps = this.getProps("contact");
        const emailProps = this.getProps("email");
        const telnumProps = this.getProps("telnum");
        return {
            ...this.props.fields,
            status: <div className="col-md-12">
                <Select
                    objectValue={false}
                    optionname="FurgeFutarStatus"
                    storeType="local"
                    name="status"
                    value={this.state?.value?.status}
                    label="Futárszolgálat státusz"
                    saveChanges={this.setFieldValue}
                    {...this.getProps("status")}
                    disabled={true}
                />
            </div>,
            contact: <div className="col-md-12">
                <TextInput
                    {...contactProps}
                    name="contact"
                    required={true}
                    label="Címzett"
                    value={this.state?.value?.contact}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || contactProps.disabled}
                />
            </div>,
            email: <div className="col-md-12">
                <TextInput
                    {...emailProps}
                    name="email"
                    required={true}
                    label="Email"
                    value={this.state?.value?.email}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || emailProps.disabled}
                />
            </div>,
            telnum: <div className="col-md-12">
                <TextInput
                    {...telnumProps}
                    name="telnum"
                    required={true}
                    label="Telefon"
                    value={this.state?.value?.telnum}
                    saveChanges={this.setFieldValue}
                    disabled={(this.props.autoFill !== false ? this.state.linkContact !== false : false) || telnumProps.disabled}
                />
            </div>,
            autoInfo: this.props.autoFill !== false && <div className="col-md-12">
                <label className="control-label">&nbsp;</label>
                <Button
                    icon={{lib: "fas", name: this.state.linkContact !== false ? "link" : "unlink"}}
                    block={true}
                    color={this.state.linkContact !== false ? "primary" : "default"}
                    tooltip={"Autómatikus kitöltés " + (this.state.linkContact !== false ? "bekapcsolva" : "kikapcsolva")}
                    onClick={() => {
                        this.setState({linkContact: !(this.state.linkContact !== false)});
                    }}
                />
            </div>,
            origin: <Fragment>
                <AddressControl
                    name="pickupaddress"
                    value={this.state?.value?.pickupaddress}
                    label="Honnan"
                    saveChanges={this.setFieldValue}
                    {...this.getProps("pickupaddress")}
                />
            </Fragment>,
            destination: <Fragment>
                <div className="col-md-12">
                    <div className="row">
                        <div className={classNames({"col-md-11": this.props.autoFill !== false, "col-md-12": this.props.autoFill === false})}>
                            <div className="row">
                                <AddressControl
                                    name="shippingaddress"
                                    value={this.state?.value?.shippingaddress}
                                    label="Hova"
                                    saveChanges={this.setFieldValue}
                                    {...shippingAddressProps}
                                    disabled={(this.props.autoFill !== false ? this.state.linkShippingAddress !== false : false) || shippingAddressProps.disabled}
                                />
                            </div>
                        </div>
                        {this.props.autoFill !== false && <div className="col-md-1">
                            <label className="control-label">&nbsp;</label>
                            <Button
                                icon={{lib: "fas", name: this.state.linkShippingAddress !== false ? "link" : "unlink"}}
                                block={true}
                                color={this.state.linkShippingAddress !== false ? "primary" : "default"}
                                tooltip={"Autómatikus kitöltés " + (this.state.linkShippingAddress !== false ? "bekapcsolva" : "kikapcsolva")}
                                onClick={() => {
                                    this.setState({linkShippingAddress: !(this.state.linkShippingAddress !== false)});
                                }}
                            />
                        </div>}
                    </div>
                </div>
            </Fragment>,
            request: <div className="col-md-12">
                <TextArea
                    name="request"
                    value={this.state?.value?.request}
                    label="Megjegyzés"
                    saveChanges={this.setFieldValue}
                    {...this.getProps("request")}
                />
            </div>
        }
    }

    render() {
        const fields = this.getFields();
        if (React.Children.count(this.props.children)) {
            return <PropsProxy fields={this.getFields()}>
                {this.props.children}
            </PropsProxy>
        } else {
            return <Fragment>
                {fields.status}
                {fields.origin}
                {fields.destination}
                {fields.request}
            </Fragment>;
        }
    }

}

export default BooklogControl;